import { Accordion } from "@inno-ui/accordion";
import { Icon, IconWeight } from "@inno-ui/icons";
import { useTranslation } from "react-i18next";

import type { ParticipantWithId } from "../../../../../types/general";

import { useAppointmentStore } from "../../../../../store/appointment/appointment-store";
import { useGeneralStore } from "../../../../../store/general/general-store";
import styles from "./added-guests-mobile.module.scss";

export function AddedGuestsMobile() {
  const { t } = useTranslation();
  const { otherParticipants, deleteParticipant, setCurrentSelectedParticipant } = useAppointmentStore();
  const { showAddGuestForm } = useGeneralStore();

  const handleEditClick = (participant: ParticipantWithId) => {
    showAddGuestForm();
    setCurrentSelectedParticipant(participant);
  };

  return (
    <Accordion title={t("guests")} noPaddings noBackground defaultExpanded>
      <div className={styles.addedGuestsWrapper}>
        {otherParticipants.map(participant => (
          <div className={styles.addedGuest} key={participant.id}>
            {/* guest info */}
            <div className={styles.guestInfo}>
              <div className={styles.guestName}>
                <p>
                  {participant.firstName}
                  {" "}
                  {participant.lastName}
                </p>
                <p>{participant.email}</p>
              </div>
              {/* action buttons */}
              <div className={styles.guestActions}>
                {/* edit guest */}
                <div className={styles.editGuest} onClick={() => handleEditClick(participant)}>
                  <Icon icon="PencilLineIcon" weight={IconWeight.Bold} />
                </div>
                <div className={styles.deleteGuest} onClick={() => deleteParticipant(participant.id)}>
                  <Icon icon="TrashLineIcon" weight={IconWeight.Bold} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Accordion>
  );
}
